import { render, staticRenderFns } from "./OverworkExpandItem.vue?vue&type=template&id=17ba2234"
import script from "./OverworkExpandItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./OverworkExpandItem.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports